module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1531cv3/tc-custom/9781426864995.jpg?1741131918776",
      "alt": "This image is the cover for the book Treasure Creek Dad, Alaskan Bride Rush"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Treasure Creek Dad, Alaskan Bride Rush\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Single father Jake Rodgers's daughter isn't happy about moving to tiny Treasure Creek, Alaska. So the former big-city businessman trades his suits for hiking boots and he books a father-daughter wilderness tour to acclimate her. But Veronica isn't buying it. Perhaps guide Casey Donner is just the person to help the girl appreciate the Klondike state's natural beauty. But could tomboy Casey, in her ponytail and cargo pants, also be what this city boy needs for a lifetime of love?"), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terri Reed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award winning, multipublished author Terri Reed writes heart-warming romance and heart-pounding suspense. Her books have appeared on Publisher's Weekly top ten, Nielsen's Bookscan top fifty, Amazon Bestseller and featured in USA Today.  You can visit her online at www.terrireed.com or email her at terrireed@sterling.net ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0